import React, { ReactElement, useState } from 'react';

import { Box, Flex, Typography, ProgressBar, ButtonIcon } from 'components';
import styled from 'styled-components';
import { ModuleDetailsState } from 'features/modules';
import { createMarkup } from 'app/utils';
import { useParams } from 'react-router-dom';

import { ProductsEvolutionContentCard } from 'features/products';

const Wrapper = styled(Flex)`
  ${(props: any) => {
    if (props['data-opened']) {
      return `
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      `;
    }

    return `
      border-radius: 4px;
    `;
  }}
`;

interface ProductsEvolutionCardProps {
  module: ModuleDetailsState;
  classUuid: string;
}

const ProductsEvolutionCard = ({ module, classUuid }: ProductsEvolutionCardProps): ReactElement => {
  const [opened, setOpened] = useState(false);

  const { productSlug } = useParams();

  return (
    <Flex flexDirection="column">
      <Wrapper data-opened={opened} bg="white" mt={2} flexWrap="nowrap" justifyContent="space-between">
        <Flex flexDirection="column">
          <Typography
            title={module.name}
            type="type2"
            color="gray_600"
            fontWeight="bold"
            pt={{ m: 2, t: 3 }}
            px={{ m: 2, t: 3 }}
            onClick={() => {
              if (Boolean(module.uuid)) {
                setOpened(!opened);
              }
            }}
            style={{ cursor: Boolean(module.uuid) ? 'pointer' : 'inherit' }}
          >
            <div dangerouslySetInnerHTML={createMarkup(module.name)} />
          </Typography>

          <Flex flexGrow={0} flexWrap="nowrap" alignItems="center" pt={1} pb={2} px={3}>
            <Box flexGrow={0} flexShrink={0} width={40}>
              <Typography type="type1" color="primary_400" fontWeight="bold">
                {`${module.completionPercentage}%`}
              </Typography>
            </Box>

            <Flex>
              <ProgressBar percent={module.completionPercentage} />
            </Flex>

            <Flex width={140} flexShrink={0} flexGrow={0} alignItems="center" justifyContent="flex-end">
              {Boolean(module.uuid) && (
                <>
                  <Typography type="type0" color="gray_500" pt="2px" pr="3px" pl={2}>
                    {module.articleCount}
                  </Typography>
                  <ButtonIcon icon="textOutline" iconWidth={13} bg="transparent" color="gray_500" />

                  <Typography type="type0" color="gray_500" pt="2px" pr="3px" pl={2}>
                    {module.videoCount}
                  </Typography>
                  <ButtonIcon icon="playBoxOutline" iconWidth={13} bg="transparent" color="gray_500" />

                  <Typography type="type0" color="gray_500" pt="2px" pr="3px" pl={2}>
                    {module.quizCount}
                  </Typography>
                  <ButtonIcon icon="checkboxOutline" iconWidth={13} bg="transparent" color="gray_500" />
                </>
              )}
            </Flex>
          </Flex>
        </Flex>

        <Flex flexGrow={0} pr={3}>
          <ButtonIcon
            icon={module.uuid ? (opened ? 'chevronUp' : 'chevronDown') : 'lock'}
            bg="transparent"
            color={Boolean(module.uuid) ? 'primary_400' : 'gray_500'}
            iconWidth={module.uuid ? 25 : 18}
            onClick={() => setOpened(!opened)}
            width={30}
            disabled={!Boolean(module.uuid)}
          />
        </Flex>
      </Wrapper>

      {opened && (
        <Flex bg="gray_100" borderBottomLeftRadius={4} borderBottomRightRadius={4} flexDirection="column">
          {module.items.map((content, index) => {
            return (
              <ProductsEvolutionContentCard
                content={content}
                index={index}
                productSlug={productSlug}
                classUuid={classUuid}
                moduleUuid={module.uuid}
                contentCount={module.contentCount}
              />
            );
          })}
        </Flex>
      )}
    </Flex>
  );
};
export default ProductsEvolutionCard;
